module.exports = __webpack_public_path__ + "static/emotions2-690128cf48e11797eba00449a9dd95cc.jpg";